import React, { PropsWithChildren } from 'react'
import Pagination from 'core/pages/Pagination'
import styled from 'styled-components'
import { mq, color } from 'core/theme'
type Props = {
    showPagination?: boolean
}

const Header = ({ showPagination, children }: PropsWithChildren<Props>) => {
    return (
        <>
            <NavigationContainer>
                <LogoLink href="/en-US/">
                    <LogoImage
                        height={32}
                        width={32}
                        src="/images/state-of-react-native-logo.png"
                    />
                    <LogoText>State of React Native 2025</LogoText>
                </LogoLink>
                <PaginationWrapper>
                    {showPagination && <Pagination /*position="top"*/ />}
                </PaginationWrapper>
            </NavigationContainer>
            <NavigationContainerMobile>
                <Hamburger>{children}</Hamburger>
                <LogoLink href="/en-US/">
                    <LogoImage
                        height={32}
                        width={32}
                        src="/images/state-of-react-native-logo.png"
                    />
                    <LogoText>State of React Native 2025</LogoText>
                </LogoLink>
            </NavigationContainerMobile>
            <PaginationWrapperMobile>
                {showPagination && <Pagination /*position="top"*/ />}
            </PaginationWrapperMobile>
        </>
    )
}

export default Header

const Hamburger = styled.div`
    height: 100%;
    margin-right: 16px;
    @media ${mq.large} {
        display: none;
    }
`

const PaginationWrapper = styled.div`
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 40px;
    @media ${mq.smallMedium} {
        padding-left: 5rem;
    }
`
const PaginationWrapperMobile = styled.div`
    position: fixed;
    bottom: 0;
    height: 83px;
    width: 100%;
    display: flex;
    z-index: 10;
    justify-content: space-between;
    background-color: ${color('brandGreen60')};
    border-top: 1px solid ${color('primary100')};
    @media ${mq.smallMedium} {
        height: 62px;
    }
    @media ${mq.large} {
        display: none;
    }
`

const NavigationContainer = styled.nav`
    position: sticky;
    top: 0;
    z-index: 200;
    background-color: ${color('brandGreen60')};
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${color('primary100')};
    @media ${mq.smallMedium} {
        display: none;
    }
`

const NavigationContainerMobile = styled.nav`
    position: sticky;
    top: 0;
    z-index: 200;
    background-color: ${color('brandGreen60')};
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${color('primary100')};
    @media ${mq.large} {
        display: none;
    }
`
const LogoLink = styled.a`
    display: flex;
    gap: 16px;
    align-items: center;


    @media ${mq.large} {
        flex 0 0 350px;
        border-right: 1px solid ${color('primary100')};
        padding: 16px 48px 16px 48px;
    }
`
const LogoImage = styled.img``
const LogoText = styled.span`
    color: ${color('primary100')};
    text-wrap: nowrap;
`
